import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { getAreaCodes } from 'src/constrains/GlobalProvider/slice';
const useGetAreaCodeText = (areaCodeUuid) => {
  const options = useSelector(getAreaCodes());
  const areaCodeInText = get(
    options.find((i) => i.uuid === areaCodeUuid),
    'areaCode',
  );
  return areaCodeInText || '';
};
export { useGetAreaCodeText };
